import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";
import {LOAD_SHOP_PRODUCT_SALE_ELEMENTS} from "./mutation-types";

export const loadShops = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/shops/collection?status='+ data.status + '&search=' + data.search).then((response) => {
            commit(types.ADD_SHOPS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const fetchShops = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/shops/collection', data).then((response) => {
            commit(types.ADD_SHOPS, response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/shop', data).then((response) => {
            commit(types.ADD_SHOP, response.data.shop)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addUsersInShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('shop/'+data.id+'/add/user',data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

// Rôle d'un collaborateur dans une boutique (role_id null = son rôle général)
export const updateUserShopRole = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('shop/' + data.shop_id + '/user/' + data.user_id + '/role', { role_id: data.role_id }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateUserInShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('shop/'+data.id+'/update/user',data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addShopNormalizedKey = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('normalized-keys-add', data)
        .then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateShopNormalizedKey = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put('normalized-keys-update/'+ data.id, data)
        .then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showShop = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('show/' +id + '/shop').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getShopNormalizationKey = ({ commit, dispatch, state }, key) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`normalized-keys/${key}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getShopCategoriesProducts = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('show/' + data.id + '/categories/products/shop?categories='+ data.categories).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/shop',data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + data.id + '/shop').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const archiveShop = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('archive/' + id + '/shop').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const unArchiveShop = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('unarchive/' + id + '/shop').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const toggleShopOpen = ({ commit }, { id, closed_message }) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('toggle-open/' + id + '/shop', { closed_message }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addProductsInShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('shop/'+ data.id+'/add/product', data).then((response) => {
            resolve(response)
            Vue.$emit('productAdded')
        }).catch((err) => {
            reject(err)
        })
    })
}


export const addProductsWithCategoriesInShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('shop/'+data.id+'/add/product/bycategory', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteProductsInBoutique = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/api/v1/delete/${data}/product/boutique`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const removeUserFromShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('shop/user/' + data.id + '/remove', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const removeProductFromShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('shop/product/' + data.id + '/remove',data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateProductInShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('shop/product/' + data.id + '/update',data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const validateShopEntry = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('shop/'+data.id+'/validate/entry',data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getShopEntryProduct = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/shop/entry/' +id + '/product').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showShopOutputProduct = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('show/shop/' + data.shop_id + '/output/' + data.output_id + '/product').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const countNoValidateOutputs = ({commit, dispatch, state}, shop_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/shop/${shop_id}/moves/novalidated`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showShopEntryProduct = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('show/shop/' + data.shop_id + '/entry/' + data.entry_id + '/product').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showShopMoveEntry = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('show/move/entry/' + data.id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
//Configuration

export const addShopStores = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('add/stores/' + data.id + '/shop', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const removeShopStores = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('remove/stores/' + data.id + '/shop', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const removeShopStore = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('remove/store/' + data.id + '/shop', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getShopStores = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/shop/' + id + '/stores').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getStoresNotInShop = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/stores/' + id + '/not_in/shop').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getShopProducts = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/shop/' +id + '/products').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const getShopProductsSaleElements = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/shop/' +id + '/products/saleElements/collection').then((response) => {
            commit(types.LOAD_SHOP_PRODUCT_SALE_ELEMENTS, response.data)

            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadShopCategories = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/shop/' +id + '/products/categories/collection').then((response) => {
            commit(types.LOAD_SHOP_CATEGORIES, response.data)

            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showShopOrderDetails = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('show/shop/' + data.shop_id + '/order/' + data.checkout_id + '/details').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const generalInformation = ({commit, dispatch, state}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('general/information').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

// En-tête, tableau de bord et écrans la demandent au même chargement : un seul appel
// à la fois, et la réponse est réutilisée 10 s (un changement de devise reste visible
// presque aussitôt)
const CURRENCY_REUSE_MS = 10000
let currencyRequest = null
let currencyFetchedAt = 0

export const getCurrency = ({commit, dispatch, state}) => {
    if (currencyRequest && Date.now() - currencyFetchedAt < CURRENCY_REUSE_MS) return currencyRequest
    currencyFetchedAt = Date.now()
    currencyRequest = new Promise((resolve, reject) => {
        window.axios.get('get/tenant/currency').then((response) => {
            commit(types.SET_SHOP_DEFAULT_CURRENCY, response.data)
            resolve(response)
        }).catch((err) => {
            currencyRequest = null
            reject(err)
        })
    })
    return currencyRequest
}

export const productAlertNotification = ({commit, dispatch, state}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('product-alert/notification').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const ecommerceOrderNotification = ({commit, dispatch, state}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('ecommerce-order/notification').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const addProductsToShop = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`shop/${data.shop_id}/entry`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

//code barre
export const getShopProductsList = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/shop/'+id +'/products/list').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const normalizationInvoice = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('generate-invoice-normalized/' + id).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
  }


export const updateShopProductStatus = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/shop/' + data.shop + '/product/' + data.product + '/status', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const loadPosCheckoutStatus = ({commit, dispatch, state}) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/pos-checkout/enum').then((response) => {
            resolve(response)
            commit(types.SET_POS_CHECKOUT_STATUS, response.data)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const checkoutPosDetails = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get(`get/pos-checkout/${id}/invoice`).then((response) => {
            resolve(response)
            commit(types.SET_POS_CHECKOUT_DETAILS, response.data)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const paidOutstanding = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        // règlement depuis le détail d'une boutique : sur la boutique de l'écran
        const { shop_id, ...payload } = data
        const url = shop_id ? `shop/${shop_id}/credits/payments` : `paid/outstanding/invoice`
        window.axios.post(url, payload, { silent: true })
        .then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const getShopUsers = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/shop/' +id + '/users/collection').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getShopBoxes = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/shop/' +id + '/boxes/collection').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updateShopPromotion = ({ commit, dispatch, state }, { shopId, promotionId, data }) => {
    return new Promise((resolve, reject) => {
        window.axios
            .post(`shop/${shopId}/update/promotion/${promotionId}`, data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}


export const shopCreatePromotion = ({ commit, dispatch, state }, { shopId, data }) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`shop/${shopId}/store/promotion`, data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}
export const loadShopAllProductSaleByCategories = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/get/shop/' +id + '/productSaleElements/groupBy/category').then((response) => {
            commit(types.LOAD_SHOP_PRODUCT_SALE_ELEMENTS_BY_CATEGORIES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

// Points rouges des boutiques : ruptures, transferts à valider, crédits en retard.
// Rechargés par le menu (ouverture, changement de page, chaque minute), au plus une fois
// toutes les 20 s : naviguer vite de page en page ne multiplie pas les appels. force : juste
// après une action qui peut les changer (voir l'intercepteur axios de main.js).
let shopAlertsLoadedAt = 0
export const loadShopAlerts = async ({ commit }, { force = false } = {}) => {
    if (!force && Date.now() - shopAlertsLoadedAt < 20000) return
    shopAlertsLoadedAt = Date.now()
    try {
        const response = await window.axios.get('get/shops/alerts', { silent: true })
        commit('SET_SHOP_ALERTS', response.data.alerts || [])
    } catch (e) {
        // alertes facultatives
    }
}
